import { Injectable, Pipe, PipeTransform } from '@angular/core';


@Pipe({
  standalone: false,
  name: 'padleadingzeros'
})

@Injectable()
export class PadLeadingZerosPipe implements PipeTransform {
  transform(string:string): string {
    if (!string) return string;
    if (string.length === 0) return string

    while(string.length < 5){
        string = 0+string
    }
    return string
      
}
}